<template>
  <v-layout class="custom-home-layout">
    <v-flex xs12>
<!--       <Carousel
        class="banner-carousel"
        :scrollPerPage="true"
        :perPage="1"
        :loop="true"
        :autoplay="true"
        @pageChange="pagechangeFunc"
        :autoplayTimeout="5000">
        <Slide v-for="(item, index) in renderBanners" class="banner" :key="index">
          <Banner :item="item" :key="item.id"/>
        </Slide>
      </Carousel> -->

      <template v-for="tag in tags">
        <TagCarousel v-if="tag.programs.length > 0" :tag="tag" :key="tag.id"></TagCarousel>
      </template>

      <!-- <TagCarousel
        v-if="watching && watching.length"
        :tag="{slug: 'Estoy viendo', programs: watching}"/>

      <TagCarousel
        v-if="myList && myList.length"
        :tag="{slug: 'Mi lista', programs: myList}"/> -->

    </v-flex>
  </v-layout>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import Banner from '@/components/Banner'
import TagCarousel from '@/components/TagCarousel'

import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Carousel,
    Slide,
    Banner,
    TagCarousel
  },
  data: () => ({
    tagsPerView: 4,
    banner: {
      action_type: 'login',
      date_end: new Date('2030-01-01').getTime(),
      date_start: new Date().getTime(),
      id: '1',
      image: '/Banner.jpg',
      image_2: '/Banner_2.jpg',
      order: 1
    }
  }),
  computed: {
    ...mapGetters(['banners', 'tags', 'myList', 'watching', 'isAuthenticated']),
    renderBanners () {
      if (true) {
        return this.banners
      } else {
        return [this.banner]
      }
    }
  },
  methods: {
    ...mapActions(['getBanners', 'getTags', 'getWatching', 'log_banner', 'getShadowPrograms']),
    pagechangeFunc(index) {
      this.$ga.event({
        eventCategory: 'category',
        eventAction: 'action',
        eventLabel: 'label',
        eventValue: 123
      })
      this.log_banner({ event: 'views', banner_id: this.banners[index].id })
    }
  },
  async created () {
    // this.getBanners()
    this.getTags()
    console.log('$router:canonical', this.$route)
  }
}
</script>

<style>
  .banner-carousel .VueCarousel-pagination {
    position: absolute;
    top: calc(100% - 100px);
  }
  .custom-home-layout {
    /*padding-bottom: 100px;*/
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #000;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .v-content__wrap {
    overflow: hidden;
  }

</style>
